import * as firebase from 'firebase';
// Initialize Firebase

let config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
};

if (process.env.REACT_APP_USE_STAGING_ENV === "true") {
  config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY_STAGING,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_STAGING,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL_STAGING,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_STAGING,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_STAGING,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_STAGING
  };
};

firebase.initializeApp(config);

export const dbSimulations = firebase.database().ref('/simulations');
export const dbUserProfile = firebase.database().ref('/userProfile');
export const dbClient = firebase.database().ref('/clients');

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const twitterProvider = new firebase.auth.TwitterAuthProvider();
export const emailProvider = new firebase.auth.EmailAuthProvider();



// WEBPACK FOOTER //
// ./src/firebase.js